export const urlApi = 'https://us-central1-missao-newton.cloudfunctions.net/astroMatch/adryane-fernandes-cruz'
